import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useOrderLines, useRemoveOrderLine } from "../hooks";
import { useMe } from "../../users/hooks/useMe";
import { UserRole } from "../../../__generated__/globalTypes";

interface IProps {
  orderId: number;
}

export const OrderLinesList: React.FC<IProps> = ({ orderId }) => {
  const { data, loading, refetch } = useOrderLines({ where: { orderId } });
  const [removeOrderLine] = useRemoveOrderLine();
  const { data: meData } = useMe();
  const isAdmin = meData?.me?.role === UserRole.Admin;

  if (loading) return <Loading />;

  if (!data?.orderLines?.results?.length) {
    return <EmptyList text="Aucune ligne de commande" />;
  }

  const handleRemove = async (id: number) => {
    if (!window.confirm("Supprimer cette ligne ? Cette action est irréversible.")) {
      return;
    }
    await removeOrderLine({ variables: { id } });
    refetch();
  };

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Libellé</TableCell>
          <TableCell header align="right">
            Quantité
          </TableCell>
          <TableCell header align="right">
            Total
          </TableCell>
          {isAdmin && (
            <TableCell header align="right">
              Actions
            </TableCell>
          )}
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.orderLines?.results?.map((line) => (
          <TableRow key={`order-line-${line.id}`} hover={false}>
            <TableCell>{line.frozenLabel}</TableCell>
            <TableCell align="right">{line.quantity}</TableCell>
            <TableCell align="right">
              {(line.lineTotalCents / 100).toFixed(2)} €
            </TableCell>
            {isAdmin && (
              <TableCell align="right">
                <span
                  className="text-red-500 cursor-pointer"
                  onClick={() => handleRemove(line.id)}
                >
                  Retirer
                </span>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
